module.exports = __webpack_public_path__ + "img/personal.3667ce07.png";